import { TRowComponentProps, TViewCommonOption } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { RowEnum } from '../../../types/enums';
import { RowRegularView } from './RowRegularView';
import { SelectorExtraView } from './SelectorExtraView';
import { SelectorRegularView } from './SelectorRegularView';

type TRowComponent = {
    /** Design version of the list widget rendering the row (`TWidget.version`). */
    version: number | undefined;
    handleClick: MouseEventHandler<HTMLButtonElement>;
    parentStyleNames?: TViewCommonOption['parentStyleNames'];
} & TRowComponentProps;

const ItemListComponent: React.FC<TRowComponent> = ({ version, handleClick, ...props }) => {
    const { value, isSelected, ...rest } = props;

    switch (props.id) {
        case RowEnum.ROW_REGULAR:
            return <RowRegularView version={version} handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_REGULAR:
            return <SelectorRegularView version={version} isSelected={isSelected} handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_EXTRA:
            return <SelectorExtraView version={version} isSelected={isSelected} handleClick={handleClick} {...rest} />;
        default:
            return <RowRegularView version={version} handleClick={handleClick} {...rest} />;
    }
};

export default ItemListComponent;
